import routerOptions0 from "/opt/build/repo/node_modules/.pnpm/nuxt@4.6.4_3ce3f796c6cc3a17c8a263c2a1a625c4/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto",
  sensitive: false
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}